export type AppKey = 'people' | 'logistics' | 'portal' | 'crm' | 'master';
export type WorkspaceRole = 'boss' | 'admin' | 'partner' | 'hr' | 'logistics' | 'sales' | 'customer';

const appRoles: Record<AppKey, readonly WorkspaceRole[]> = {
    people: ['boss', 'admin', 'hr'],
    logistics: ['boss', 'admin', 'logistics'],
    portal: ['boss', 'admin', 'customer'],
    crm: ['boss', 'admin', 'sales'],
    master: ['boss', 'admin', 'partner']
};

export interface Membership {
    organization_id: string;
    customer_account_id: string | null;
    role: WorkspaceRole;
    active: boolean;
    organizations: { name: string } | null;
}

export function canOpenApp(app: AppKey, role: WorkspaceRole): boolean {
    return appRoles[app].includes(role);
}

export function canManageMaster(role: WorkspaceRole): boolean {
    return role === 'boss' || role === 'admin';
}

export function canWriteApp(app: AppKey, role: WorkspaceRole): boolean {
    if (role === 'partner' || role === 'customer') return false;
    return canOpenApp(app, role);
}
